import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Card,
  Button,
  Table,
  Tooltip,
  Select,
  Input,
  BackTop,
  Modal,
  Tag,
  message,
} from "antd";

import { connect } from "react-redux";
import {
  req_page_tqa_b06,
  req_edit_tqa_b06,
  req_delete_tqa_b06,
  req_edit_tqa_worker,
  req_list_tqa_department_log,
  // req_edit_tqa_reviewOpinion,
  // req_edit_tqa_reviewCheck,
  req_add_tqa_log,
} from "../../api";

import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";

import HistoryLogsDepartmentModal from "./history-logs-department-modal";
import QuailtyManualLevelBModal from "./quailty-manual-level-b-modal";
import ReviewSchoolCommitModal from "./review-school-commit-modal";
class CollegeQuailtyB06 extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    department: PropTypes.object.isRequired,
  };

  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    logs: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",

    domnloadFile: "",
    academicYear: this.props.department.AcademicYear,
    isShowModal: false,
    isEditModal: false,
    isCommitModal: false,
    isLogModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { DepartmentCode } = this.props.department;
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      academicYear,
    } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.api_page_run(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      DepartmentCode,
      token
    );
  };

  api_page_run = async (
    userCode,
    userLevel,
    current,
    pageSize,
    columnSort,
    orderBy,
    searchField,
    searchValue,
    filterStatus,
    academicYear,
    departmentCode,
    token
  ) => {
    this.setState({ loading: true });
    const result = await req_page_tqa_b06(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      departmentCode,
      token
    );
    //console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
    this.setState({ loading: false });
  };

  api_delete_item = async (key) => {
    const { token } = this.props.user;
    const result = await req_delete_tqa_b06(key, token);

    if (result.status === "success") {
      message.success("刪除成功");
      this.api_page_items(this.current);
    } else {
      //console.log(result)
    }
  };

  api_edit_item = async (item) => {
    const { token } = this.props.user;
    this.setState({ loading: true });
    const result = await req_edit_tqa_b06(item, token);
    this.setState({ loading: false });
    //console.log(result);
    if (result.status === "success") {
      message.success(result.message);
      this.api_page_items(this.current);
    } else {
      message.error(result.message);
    }
  };

  api_edit_status = async (item) => {
    const { token } = this.props.user;
    await req_edit_tqa_worker(item, token);
    // await req_edit_tqa_reviewOpinion(item, token);
    // await req_edit_tqa_reviewCheck(item, token);
  };

  api_page_logs = async (item) => {
    const { academicYear } = this.state;
    const { DepartmentCode } = item;
    const { token, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    const result = await req_list_tqa_department_log(
      academicYear,
      DepartmentCode,
      token
    );
    if (result.total > 0) {
      const logs = result.data;
      this.setState({ logs }, () => {
        this.setState({ isLogModal: true });
      });
    } else {
      const logs = [];
      message.info("查無資料");
      this.setState({ logs });
    }
  };

  api_add_log = async (item) => {
    const { token } = this.props.user;
    await req_add_tqa_log(item, token);
  };

  api_downloadfile = async (fileUrl) => {
    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    const { SchoolJudgeStatusA, SchoolJudgeStatusB, SchoolJudgeReviewStatus } =
      this.props.department;
    this.columns = [
      {
        title: "學年度",
        dataIndex: "AcademicYear",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "文件名稱",
        dataIndex: "RecordTitle",
        width: 50,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "版本",
        width: 30,
        responsive: ["md"],
        render: (item) => {
          const { RecordVersion } = item;
          return (
            <div className="text-center">
              <Tag>{RecordVersion}</Tag>
            </div>
          );
        },
      },
      {
        title: "進度",
        width: 20,
        responsive: ["md"],
        render: (item) => {
          const { RecordStatus } = item;
          return (
            <div className="text-center">
              <Tag color={this.style_switch_color_tag(RecordStatus)}>
                {this.style_switch_text_tag(RecordStatus)}
              </Tag>
            </div>
          );
        },
      },
      {
        title: "",
        dataIndex: "",
        width: 65,
        render: (item) => {
          const { WorkManualVersion } = this.props.department;
          const { RecordFileUrl, RecordStatus } = item;
          return (
            <>
              {" "}
              {RecordStatus !== "EDIT" ? (
                <button
                  type="button"
                  className="btn btn-outline-dark btn-sm"
                  onClick={() => this.handle_show_ui_modal("LOG", item)}
                >
                  <i className="fa fa-align-justify"></i>
                  <span style={{ marginLeft: "2px" }}>歷程</span>
                </button>
              ) : (
                ""
              )}
              {RecordFileUrl === "NA" || RecordFileUrl === "" ? (
                ""
              ) : (
                <>
                  <button
                    type="button"
                    className="btn btn-outline-dark btn-sm"
                    onClick={() => this.api_downloadfile(RecordFileUrl)}
                  >
                    <i className="fas fa-cloud-download-alt"></i>
                    <span style={{ marginLeft: "4px" }}>下載</span>
                  </button>
                </>
              )}
              {RecordStatus === "EDIT" ? (
                <>
                  <button
                    type="button"
                    className="btn btn-outline-dark btn-sm"
                    onClick={() => this.handle_show_ui_modal("EDIT", item)}
                  >
                    <i className="fa fa-retweet"></i>
                    <span style={{ marginLeft: "2px" }}>重傳</span>
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-dark btn-sm"
                    onClick={() => this.handle_show_ui_modal("DELETE", item)}
                  >
                    <i className="fa fa-trash"></i>
                    <span style={{ marginLeft: "2px" }}>刪除</span>
                  </button>
                  {WorkManualVersion ? (
                    ""
                  ) : (
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => this.handle_show_ui_modal("CHECK", item)}
                    >
                      <i className="fa fa-eye"></i>
                      <span style={{ marginLeft: "2px" }}>送審</span>
                    </button>
                  )}
                </>
              ) : (
                <>
                  {SchoolJudgeStatusA === "SUBMIT" &&
                  RecordStatus === "SUBMIT" ? (
                    <button
                      type="button"
                      className={"btn btn-outline-dark btn-sm"}
                      onClick={() =>
                        this.handle_show_ui_modal("COMMIT_A", item)
                      }
                    >
                      <i className="fa fa-bullhorn"></i>
                      <span style={{ marginLeft: "2px" }}>校評一</span>
                    </button>
                  ) : (
                    ""
                  )}
                  {SchoolJudgeStatusB === "SUBMIT" &&
                  RecordStatus === "SUBMIT" ? (
                    <button
                      type="button"
                      className={"btn btn-outline-dark btn-sm"}
                      onClick={() =>
                        this.handle_show_ui_modal("COMMIT_B", item)
                      }
                    >
                      <i className="fa fa-bullhorn"></i>
                      <span style={{ marginLeft: "2px" }}>校評二</span>
                    </button>
                  ) : (
                    ""
                  )}
                  {SchoolJudgeReviewStatus === "FINISH" &&
                  RecordStatus === "SUBMIT" ? (
                    <>
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => this.handle_show_ui_modal("EDIT", item)}
                        disabled={RecordStatus === "DONE"}
                      >
                        <i className="fa fa-retweet"></i>
                        <span style={{ marginLeft: "2px" }}>更檔</span>
                      </button>
                      <button
                        type="button"
                        className={"btn btn-outline-danger btn-sm"}
                        onClick={() =>
                          this.handle_show_ui_modal("COMMIT_ALL", item)
                        }
                        disabled={RecordStatus === "DONE"}
                      >
                        <i className="fa fa-check-square"></i>
                        <span style={{ marginLeft: "2px" }}>定版</span>
                      </button>
                    </>
                  ) : (
                    ""
                  )}
                </>
              )}
              {RecordStatus === "RELEASE" ? (
                <>
                  <button
                    type="button"
                    className="btn btn-outline-danger btn-sm"
                    onClick={() => this.handle_show_ui_modal("CANCEL", item)}
                  >
                    <i className="fa fa-ban"></i>
                    <span style={{ marginLeft: "2px" }}>註銷</span>
                  </button>
                </>
              ) : (
                <></>
              )}
            </>
          );
        },
      },
    ];
  };

  style_switch_text_tag(column) {
    let ans = "其他";
    switch (column) {
      case "INIT":
        ans = "初始化";
        break;
      case "EDIT":
        ans = "規劃中";
        break;
      case "CHECK":
        ans = "簽核中";
        break;
      case "VETO":
        ans = "已退件";
        break;
      case "SUBMIT":
        ans = "已送審";
        break;
      case "DONE":
        ans = "已完成";
        break;
      case "CANCEL":
        ans = "已註銷";
        break;
      default:
        // OTHER
        break;
    }
    return ans;
  }

  style_switch_color_tag(column) {
    let ans = "#FFFFFF";
    switch (column) {
      case "INIT":
        ans = "#33ECFF";
        break;
      case "EDIT":
        ans = "#108EE9";
        break;
      case "CHECK":
        ans = "#FF7300";
        break;
      case "VETO":
        ans = "#808080";
        break;
      case "SUBMIT":
        ans = "#AF982C";
        break;
      case "DONE":
        ans = "#87D068";
        break;
      case "CANCEL":
        ans = "#FF0000";
        break;
      default:
        ans = "#FFFFFF";
        break;
    }
    return ans;
  }

  // 操作互動處理 //////////////////////////////////////////////

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_show_ui_modal = (modal, item) => {
    const { Uid, RecordVersion, RecordStatus } = item;
    const { userCode, userName } = this.props.user;
    const {
      WorkGuid,
      AcademicYear,
      WorkTypeCode,
      DepartmentCode,
      DepartmentName,
      SchoolJudgeCodeA,
      SchoolJudgeNameA,
      SchoolJudgeCodeB,
      SchoolJudgeNameB,
    } = this.props.department;
    switch (modal) {
      case "LOG":
        this.api_page_logs(item);
        break;
      case "ADD":
        const obj = {
          DepartmentCode: DepartmentCode,
          DepartmentName: DepartmentName,
          RecordEditor: userCode,
          RecordCreator: userCode,
        };
        // console.log("obj", obj);
        this.setState({ isAddModal: true, item: obj });
        break;
      case "EDIT":
        this.setState({ isEditModal: true, item });
        break;
      case "DELETE":
        Modal.confirm({
          title: `您確定刪除此筆檔案!`,
          onOk: () => {
            this.api_delete_item(Uid);
          },
        });
        break;
      case "CHECK":
        var row = {
          Uid: Uid,
          RecordEditor: userCode,
          RecordVersion: RecordVersion,
          condition: "CHECK",
        };
        const log_check = {
          LogUid: WorkGuid,
          RecordType: "MAIN",
          DepartmentCode: DepartmentCode,
          RecordDescription:
            AcademicYear +
            "學年度-" +
            userName +
            "提交" +
            DepartmentName +
            "教學品保報告簽核，版號：" +
            RecordVersion,
          RecordCreator: userCode,
        };
        Modal.confirm({
          title: `送審後將無法刪除，且將提供院長/中心主任、校評委員審查，是否確定送審?`,
          onOk: () => {
            this.api_edit_item(row);
            this.api_add_log(log_check);
          },
        });
        break;
      case "CANCEL":
        row = {
          Uid: Uid,
          RecordEditor: userCode,
          condition: "CANCEL",
        };
        Modal.confirm({
          title: `註銷後將無法提供下載，是否確定註銷?`,
          onOk: () => {
            this.api_edit_item(row);
          },
        });
        break;
      case "COMMIT_A":
        const data_a = {
          AcademicYear,
          WorkTypeCode,
          WorkManualVersion: RecordVersion,
          DepartmentCode,
          DepartmentName,
          SchoolJudgeCode: SchoolJudgeCodeA,
          SchoolJudgeName: SchoolJudgeNameA,
          ContentUserCode: SchoolJudgeCodeA,
          ContentUserName: SchoolJudgeNameA,
          CommitUserCode: userCode,
          CommitUserName: userName,
          WorkManualStatus: RecordStatus,
        };
        this.setState({ isCommitModal: true, item: data_a });
        //console.log(data_a);
        break;
      case "COMMIT_B":
        const data_b = {
          AcademicYear,
          WorkTypeCode,
          WorkManualVersion: RecordVersion,
          DepartmentCode,
          DepartmentName,
          SchoolJudgeCode: SchoolJudgeCodeB,
          SchoolJudgeName: SchoolJudgeNameB,
          ContentUserCode: SchoolJudgeCodeB,
          ContentUserName: SchoolJudgeNameB,
          CommitUserCode: userCode,
          CommitUserName: userName,
          WorkManualStatus: RecordStatus,
        };
        this.setState({ isCommitModal: true, item: data_b });
        //console.log(data_b);
        break;
      case "COMMIT_ALL":
        row = {
          Uid: Uid,
          RecordEditor: userCode,
          condition: "RELEASE",
        };
        const status = {
          WorkManualVersion: RecordVersion,
          condition: "RELEASE",
        };
        const log_release = {
          LogUid: WorkGuid,
          RecordType: "MAIN",
          DepartmentCode: DepartmentCode,
          RecordDescription:
            AcademicYear +
            "學年度-" +
            userName +
            "提交" +
            DepartmentName +
            "教學品保報告定稿，版號：" +
            RecordVersion,
          RecordCreator: userCode,
        };
        Modal.confirm({
          title: `若已依各審查委員意見修訂文件，請按確定`,
          onOk: () => {
            this.api_edit_item(row);
            this.api_edit_status(status);
            this.api_add_log(log_release);
          },
        });
        break;
      default:
        break;
    }
  };

  handle_ui_field_change = (target_key, target_field, e) => {
    const value = e.target.value;
    const item = {
      activityNid: target_key,
      setPoints: value,
      condition: target_field,
    };
    //console.log(target_key)
    this.api_modify_item(item);
  };

  /////////////////////////////////////////////////////////////

  render() {
    const { WorkManualStatus } = this.props.department;
    //console.log(this.props.department);
    const {
      loading,
      logs,
      item,
      items,
      pagination,
      searchField,
      searchValue,
      academicYear,
      isEditModal,
      isAddModal,
      isCommitModal,
      isLogModal,
    } = this.state;
    const title = (
      <>
        <Input
          placeholder="學年"
          style={{ width: 55, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={academicYear}
          onChange={(event) =>
            this.setState({ academicYear: event.target.value })
          }
        />
        <Select
          value={searchField}
          style={{ width: 120, backgroundColor: "LightCyan" }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="RecordTitle">文件名稱</Select.Option>
          <Select.Option value="RecordVersion">版本</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 80, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>
        {WorkManualStatus === "DONE" ? (
          ""
        ) : (
          <Button
            type="primary"
            onClick={() => this.handle_show_ui_modal("ADD", {})}
            style={{ marginLeft: "4px" }}
          >
            <i className="fas fa-plus"></i>
            <span style={{ marginLeft: "4px" }}>新增</span>
          </Button>
        )}
      </>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Uid"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <Modal
          destroyOnClose={true}
          visible={isLogModal}
          width={"600px"}
          onOk={() => {
            this.setState({ isLogModal: false });
          }}
          onCancel={() => {
            this.setState({ isLogModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <HistoryLogsDepartmentModal logs={logs} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isEditModal}
          width={600}
          onOk={() => {
            this.setState({ isEditModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isEditModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <QuailtyManualLevelBModal manual={item} modalstate={"isEditModal"} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isAddModal}
          width={600}
          onOk={() => {
            this.setState({ isAddModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isAddModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <QuailtyManualLevelBModal manual={item} modalstate={"isAddModal"} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isCommitModal}
          width={"70%"}
          okText="關閉"
          onOk={() => {
            this.setState({ isCommitModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isCommitModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <ReviewSchoolCommitModal worker={item} />
        </Modal>
        <BackTop visibilityHeight="80" />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(CollegeQuailtyB06);
